var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"neko-message-list neko-chat-scroll"},_vm._l((_vm.messages.slice(-(_vm.messagesLimit || 100))),function(message){return _c('message-list-item',{key:message.id,attrs:{"message":message}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }